import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {
    CollectionMethod,
    Invoice
} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<Invoice, 'id'>,
    handleSubmit: (values: Invoice) => void,
    handleCancel?: () => void
}) => {

    const onSubmit = (values: Invoice) => {
        handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {
        collectionMethod: CollectionMethod.send_invoice,
        currency: 'usd',
        daysUntilDue: 30,
    } as Invoice;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent handleSubmit={handleSubmit} isSubmitting={isSubmitting} {...rest}/>
                </FormWithButtons>)}
        </Formik>
    );
};
